import React, { useEffect, useState } from 'react'
import { eye_icon, left_arrow } from '../../assets/imgs';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAdminAddMutation, useAdminEditMutation, useAdminListRoleQuery, useLazyAdminListRoleQuery, useLazyAdminListViewQuery } from '../redux/api/api';
import { toast } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';

const AdminAdd = () => {

    const [adminListView] = useLazyAdminListViewQuery();
    const [adminEditApi] = useAdminEditMutation();
    const [adminRolesApi] = useLazyAdminListRoleQuery();
    const [adminListAdd] = useAdminAddMutation();
    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    const [visible, setVisible] = useState(false);
    const [verifyVisible, setVerifyVisible] = useState(false);
    const [rolesList, setRolesList] = useState([]);
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [number, setNumber] = useState();
    const [roles, setRoles] = useState();
    const [password, setPassword] = useState();
    const [confirmPass, setConfirmPass] = useState();
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const id = location?.state?.id;
    const type = location?.state?.type;
    console.log("id", location?.state);


    const adminView = (id) => {
        adminListView(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.admin) {
                    setName(res?.admin?.username);
                    setEmail(res?.admin?.email);
                    setNumber(res?.admin?.mobile);
                    setRoles(res?.admin?.role?.id);
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const adminAdd = () => {

        const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        if (!email || !regEx.test(email)) {
            toast.error("Enter Valid Email");
            return;
        } if (!number) {
            toast.error("Enter Number");
            return;
        } if (!roles) {
            toast.error("Enter Roles");
            return;
        } if (!password) {
            toast.error("Enter Password");
            return;
        } if (!confirmPass) {
            toast.error("Enter Confirm Password");
            return;
        }
        setLoader(true);
        const formdata = new FormData();
        formdata.append("username", name);
        formdata.append("email", email);
        formdata.append("mobile", number);
        formdata.append("role_id", roles);
        formdata.append("password", password);
        formdata.append("confirm_password", confirmPass);
        adminListAdd(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    navigate(-1);
                }

            })
            .catch((err) => {
                setLoader(false);
                console.log("err", err);
            }).finally(() => {
                setLoader(false)
            })

    }
    const adminEdit = () => {
        const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        if (!email || !regEx.test(email)) {
            toast.error("Enter Valid Email");
            return;
        } if (!number) {
            toast.error("Enter Number");
            return;
        } if (!roles) {
            toast.error("Enter Roles");
            return;
        }
        const formdata = new FormData();
        formdata.append("id", id);
        formdata.append("username", name);
        formdata.append("email", email);
        formdata.append("mobile", number);
        formdata.append("role_id", roles);
        formdata.append("password", password);
        formdata.append("confirm_password", confirmPass);
        setLoader(true);
        adminEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    navigate(-1);
                }

            })
            .catch((err) => {
                setLoader(false);
                console.log("err", err);
            })
    }

    const adminRoles = () => {
        adminRolesApi()
            .unwrap()
            .then((res) => {
                console.log("resRoles", res);
                if (res?.status == "success") {
                    setRolesList(res?.admins)
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        adminRoles();
        if (location?.state?.id) {
            adminView(location?.state?.id);
        }
    }, []);
    console.log("list", roles);

    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Admin
                </h2>
            </div>

            <div className='d-flex ac-js gap-2'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>

            <div className="">
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Name *
                        </h4>
                        <input readOnly={type == "view"} type="text" onChange={(e) => setName(e.target.value)} value={name} className="input-pop ps-2 w-100" placeholder=" Name" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Email *
                        </h4>
                        <input readOnly={type == "view"} type="email" onChange={(e) => setEmail(e.target.value)} value={email} className="input-pop ps-2 w-100" placeholder=" Email Address" />
                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Phone Number *
                        </h4>
                        <input readOnly={type == "view"} type="number" onInput={(e) => e.target.value = e.target.value.slice(0, 10)} onChange={(e) => setNumber(e.target.value)} value={number} className="input-pop ps-2 w-100" placeholder="Phone Number" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Roles *
                        </h4>
                        <select onChange={(e) => { setRoles(e.target.value) }} disabled={type == "view"} value={roles} className='input-pop ps-2 w-100'>
                            <option> Select Roles</option>
                            {rolesList.map((item) => {
                                return (
                                    <option value={item?.id}> {item.role}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>
                    {type != "view" && (
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Password {type != "edit" ? "*" : ""}
                            </h4>
                            <div className="input-pop mb-2 w-100 d-flex ac-jb">
                                <input readOnly={type == "view"}
                                    type={visible ? "text" : "password"}
                                    maxLength={20}
                                    className="cust-btn  w-90 "
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}

                                />
                                {!visible && (
                                    <img
                                        src={eye_icon}
                                        onClick={() => setVisible(!visible)}
                                        className="eye-icon pointer primary1"
                                        alt=""
                                    />
                                )}
                                {visible && (
                                    <div onClick={() => setVisible(!visible)} className="pointer sec">
                                        <VisibilityIcon className="eye-icon " />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {type != "view" && (
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Confirm Password {type != "edit" ? "*" : ""}
                            </h4>
                            <div className="input-pop mb-2 w-100 d-flex ac-jb ">
                                <input readOnly={type == "view"}
                                    type={verifyVisible ? "text" : "password"}
                                    maxLength={20}
                                    className="cust-btn w-90"
                                    placeholder=" Confirm Password"
                                    value={confirmPass}
                                    onChange={(e) => setConfirmPass(e.target.value)}
                                />
                                {!verifyVisible && (
                                    <img
                                        src={eye_icon}
                                        onClick={() => setVerifyVisible(!verifyVisible)}
                                        className="eye-icon pointer "
                                        alt=""
                                    />)}
                                {verifyVisible && (
                                    <div onClick={() => setVerifyVisible(!verifyVisible)} className="pointer sec">
                                        <VisibilityIcon className="eye-icon " />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                {type != "view" && (
                    <div className="col-md-11 d-flex ac-je pe-4">
                        {(rolePermissions?.includes('CAN-ADD-ADMIN') || rolePermissions?.includes('CAN-EDIT-ADMIN')) &&
                            <button onClick={() => type == "edit" ? adminEdit() : adminAdd()} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )}  Submit
                            </button>
                        }
                    </div>
                )}
            </div>
        </div>
    )
}

export default AdminAdd